import { type Dayjs } from "dayjs";

import { type UserRoleEnum } from "@fitness-app/data-models";
import {
  type CalendarEventFilterCondition,
  type TraineeTagFilterCondition,
} from "@fitness-app/data-models/entities/AutomationTemplate";

import { type CRMTagFilterConditionField } from "~/modules/Automation/AutomatedMessagesForm/types";
import { type MessageAttachmentsFormValues } from "~/modules/Chat/components/MessageAttachments/MessageAttachmentsFormItems";

export enum FormMode {
  Calendar,
  Template,
  Template_Add,
}

export const weekDayLabels = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"] as const;

export type WeekdayLabels = (typeof weekDayLabels)[number];

export interface MessageComposeFormModel extends MessageAttachmentsFormValues {
  id: string | null;
  mode: FormMode;
  name: string;
  messages: string[];
  authorId: string;
  authorName: string;
  authorRole: UserRoleEnum;
  authorAvatar: string | null;
  sendImmediately: boolean;
  sentDate?: Dayjs;
  sentTime: Dayjs;
  saveAsTemplate?: boolean;
  daysOfDelivery?: WeekdayLabels[];
  numberOfRepeats?: number;
  filters?: (TraineeTagFilterCondition | CalendarEventFilterCondition | CRMTagFilterConditionField)[];
}

export type SelectedUsersListItem = {
  id: string;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  assignedTrainerId: string | null;
  /** Embedded team member — used only for the trainer filter in the pickable list. */
  assignedTrainer?: { id: string; firstName: string; lastName: string } | null;
  /** AppAccessType — limited clients are pickable but hidden behind the access filter by default. */
  type?: string;
  /** Embedded through product_client — used only for filtering the pickable list. */
  productClient?: { product: { id: string; name: string } | null } | null;
};
